<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="pgepubid00000">
<h1 class="calibre3">Mrs. Harter</h1>
</div>
<div class="titlepage" id="calibre_pb_1">
<p class="calibre4"><i class="calibre5">By</i><br class="calibre6"/>
<span class="large">E. M. Delafield</span><br class="calibre6"/>
<i class="calibre5">Author of “The Heel of Achilles,”<br class="calibre6"/>
“The Optimist,” Etc.</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section001.vue?656593b8